module.exports = __webpack_public_path__ + "img/header-weddingRingsMulticolor.39ba7fd.webp";